import { useQueryParam } from './useQueryParam';

export const useQueryParamString = (paramName: string, callback: (value: string | null) => void) =>
  useQueryParam(paramName, (paramValue) => {
    callback(paramValue ? String(paramValue) : null);
  });
